import { useBulkApiKeyRoleDelete } from "shared/Role/useDeleteApiKeyRole";

import { ApiKeyViewRoleBinding } from "../../../types";
import { BULK_ACTION_NAMES, BULK_ACTION_RESULTS_TITLE } from "../constants";
import { ApiKeyRolesActionItemForBulkActions } from "./types";
import { ApiKeyRolesBulkActions } from "../types";

const useDeleteApiKeyRolesBulkAction = (): ApiKeyRolesActionItemForBulkActions => {
  const [deleteApiKeyRole] = useBulkApiKeyRoleDelete();

  return {
    key: ApiKeyRolesBulkActions.Delete,
    title: BULK_ACTION_NAMES[ApiKeyRolesBulkActions.Delete],
    resultTitle: BULK_ACTION_RESULTS_TITLE[ApiKeyRolesBulkActions.Delete],
    condition: () => true, // For now, always allow deletion - can be defined later if needed
    mutation: (roleBinding: ApiKeyViewRoleBinding) => deleteApiKeyRole({ id: roleBinding.id }),
  };
};

export default useDeleteApiKeyRolesBulkAction;
